import CloseIcon from '../../../assets/icons/close.svg?react';
import { useState } from 'react';
import {useAlgoList} from '../../../hooks/queries/algoQueries';
import { useUpdateSetUp } from '../../../hooks/queries/setUpQueries';
import { useAuth } from '../../../hooks/useAuth';
import Pagination from '../../../components/Pagination/Pagination';
const SystemSetUpCblEditModal = ({ onClose, onSuccess }) => {
  const { user } = useAuth();
  const [isPending, setIsPending] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { data: algoList, isLoading: isLoadingAlgoList, error: errorAlgoList } = useAlgoList({
    Page: currentPage,
    PageSize: pageSize,
    OrderBy: 'CreatedDate',
    OrderDirection: 'desc',
  });
  const totalPages = Math.ceil(algoList?.Total / pageSize);
  const [selectedAlgo, setSelectedAlgo] = useState(null);
  const updateSetUp = useUpdateSetUp();
  const handleUpdateSetUp = async () => {
    try {
      setIsPending(true);
      await updateSetUp.mutateAsync({
        group: 'DefaultCBL',
        key: 'DEFAULT_MODULE_NAME',
        value: selectedAlgo.ModuleName,
        updatedBy: user.UserSysId,
      });
      await updateSetUp.mutateAsync({
        group: 'DefaultCBL',
        key: 'DEFAULT_MODULE_VERSION',
        value: selectedAlgo.Version,
        updatedBy: user.UserSysId,
      });
      onSuccess();
    } catch (error) {
      console.error('CBL 연산 모듈 수정 실패:', error);
      alert('CBL 연산 모듈 수정에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  }
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header">
          <h3>CBL 연산 모듈 수정</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content mt-5">
          <div className='primary-table w-full'>
            <table>
              <thead>
                <tr>
                  <th width="40px"></th>
                  <th>모듈명</th>
                  <th>버전</th>
                  <th>API 엔드포인트</th>
                </tr>
              </thead>
              <tbody>
                {algoList?.Items?.map((algo) => (
                  <tr key={algo.CblModuleInfoSysId}>
                    <td>
                      <input type="checkbox" checked={selectedAlgo?.CblModuleInfoSysId === algo.CblModuleInfoSysId} onChange={() => setSelectedAlgo(algo)} />
                    </td>
                    <td>{algo.ModuleName}</td>
                    <td>{algo.Version}</td>
                    <td>{algo.BaseUrl}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="pagination-wrapper">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              size="small"
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn big-btn btn-primary" onClick={onClose}>취소</button>
          <button className="btn big-btn btn-style-5" onClick={handleUpdateSetUp} disabled={isPending || !selectedAlgo}>{isPending ? '수정 중...' : '수정'}</button>
        </div>
      </div>
    </div>
  )
}

export default SystemSetUpCblEditModal;